import React, { useContext, useState } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import RouteContext from 'src/routes/context';
import { getAllFilters } from '../utils/filters-config';
import { defaultHiddenListOptions } from '../utils';
import FilterOption from './filter-option';
import { FilterPanel } from '../styles';

export const AllFilters: React.FC = () => {
  const { t, market } = useContext(AppContext);
  const { dispatch: routeDispatch } = useContext(RouteContext);
  const { selectedFilters, changeSingleFilterSelection } = useContext(
    PriceListFilterContext
  );
  const [hiddenListOptions] = useState<string[]>(
    defaultHiddenListOptions(market)
  );
  const filtersConfig = getAllFilters(t, selectedFilters, hiddenListOptions);

  const onProductTypeFilterChanged = (name: string, val: boolean) => {
    changeSingleFilterSelection(name, val, routeDispatch);
  };

  return (
    <>
      <FilterPanel data-testid="FilterOptions">
        {filtersConfig.map(f => {
          return (
            !f.hide &&
            !f.quickFilter && (
              <FilterOption
                key={f.name}
                name={f.name}
                defaultValue={f.checked}
                onFilterChangedHandler={onProductTypeFilterChanged}
                label={f.label}
                caption={f.caption}
              />
            )
          );
        })}
      </FilterPanel>
    </>
  );
};
